export const quarters = [
  {
    name: "PRIMER TRIMESTRE",
    id: 182,
  },
  {
    name: "SEGUNDO TRIMESTRE",
    id: 64,
  },
  {
    name: "TERCERO TRIMESTRE",
    id: 46,
  },
  {
    name: "CUARTO TRIMESTRE",
    id: 47,
  },
];
